import React from 'react';
import {ComponentSize, ComponentVariant} from '..';


export interface FormControlContextValue {
  variant?: ComponentVariant;
  size?: ComponentSize;
  disabled?: boolean;
  error?: boolean;
  focused?: boolean;
  fullWidth?: boolean;
  required?: boolean;
  onBlur?: React.FocusEventHandler;
  onFocus?: React.FocusEventHandler;
}

const FormControlContext = React.createContext<FormControlContextValue | null | undefined>(undefined);

export default FormControlContext;
